__turbopack_context__.v({
  "activePage": "Pagination-module-scss-module__EH1liG__activePage",
  "ellipsis": "Pagination-module-scss-module__EH1liG__ellipsis",
  "nextPage": "Pagination-module-scss-module__EH1liG__nextPage",
  "pageButton": "Pagination-module-scss-module__EH1liG__pageButton",
  "pagination": "Pagination-module-scss-module__EH1liG__pagination",
  "prevPage": "Pagination-module-scss-module__EH1liG__prevPage",
});
